module.exports = __webpack_public_path__ + "static/media/9-9.b3e32cab.mp3";